import { render, staticRenderFns } from "./PaymentPacks.vue?vue&type=template&id=4e8e2150&"
import script from "./PaymentPacks.vue?vue&type=script&lang=js&"
export * from "./PaymentPacks.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports